export class ArchiveUsersRequestDTO {
  constructor(public userIds: string[]) {}
}
